<template>
  <div>
    <!-- ================= DETALLE CON CARIÑO ================= -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Lluvia de</span><br />
          <span class="script">Sobres</span>
        </h2>

        <p ref="textoRef" class="texto">
          Tu presencia es el regalo más valioso para mí. ✨  
          Pero si deseas tener un detalle, lo recibiré con mucho aprecio  
          y profunda gratitud, sin ser en absoluto una obligación.
        </p>

        <img
          ref="sobreRef"
          :src="sobrePng"
          alt="Sobre"
          class="icono-sobre"
        />

        <p ref="graciasRef" class="gracias">Lluvia de sobres</p>
      </div>
    </section>

    <!-- ================= NIÑOS ================= -->
    <section ref="raizNinos" class="lluvia-sobres">
      <div class="contenido">
        <!-- Separador -->
     <div ref="separadorNinosRef" class="separador-contenedor">
          <span class="linea"></span>
          <span class="rombo">◆</span>
          <span class="linea"></span>
        </div>

        <h2 ref="tituloNinosRef" class="titulo">
          <span class="serif"> No Niños</span>
        </h2>

        <p ref="textoNinosRef" class="texto">
          Apreciamos sus pequeños, pero hemos decidido celebrar este momento sin niños.
        </p>

        <p ref="graciasNinosRef" class="gracias"></p>
      </div>

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss2.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {

    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const cashRef = ref(null)

    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const separadorNinosRef = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let stInstance = null
    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: 0, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 1,
            duration: 2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {

          const titulos = raiz.value.querySelectorAll('.titulo')

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 🔥 PRIMER TÍTULO (Lluvia)
          tl.from(titulos[0], { opacity: 0, y: 30, duration: 0.6 })

            .from(textoRef.value, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
            .from(sobreRef.value, { opacity: 0, scale: 0.7, duration: 0.6 }, '-=0.3')
            .from(lluviaTextoRef.value, { opacity: 0, y: 20 }, '-=0.3')

            // 🔥 SEGUNDO TÍTULO (Cash App)
            .from(titulos[1], { opacity: 0, y: 30, duration: 0.6 })

            // 🔥 CASH APP
            .from(cashRef.value, {
              opacity: 0,
              y: 40,
              scale: 0.9,
              duration: 0.7,
              ease: "back.out(1.7)"
            })

            // 🔥 GRACIAS AL FINAL
            .from(graciasRef.value, { opacity: 0, y: 20, duration: 0.4 })

          crearLluvia(lluviaDer.value)
          crearLluvia(lluviaIzq.value)
        }
      })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          gsap.timeline({ defaults: { ease: 'power3.out' } })
            .from(separadorNinosRef.value, { opacity: 0, scaleX: 0, duration: 0.6 })
            .from(tituloNinosRef.value, { opacity: 0, y: 30, duration: 0.6 }, '-=0.3')
            .from(textoNinosRef.value, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        }
      })
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      lluviaTextoRef,
      graciasRef,
      cashRef,
      lluviaIzq,
      lluviaDer,
      raizNinos,
      separadorNinosRef,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
.cash-container{
  margin-top: 20px;
  text-align: center;
}

.cash-img{
  width: 140px;
  margin: 10px auto;
  display: block;
}

.cash-link{
  display: block;
  color: white;
  font-size: 22px !important;
  margin-top: 8px;
  text-decoration: underline;
}

.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 8px 20px 56px;
  text-align: center;
  background: #eaadc0;
  overflow: hidden;
}
.contenido{ position: relative; z-index: 2; }

/* Separador */
.separador-contenedor {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  transform-origin: center;
}

.separador-linea {
  border: none;
  height: 1.5px;
  background: rgba(255, 255, 255, 0.6);
  width: 60px;
  margin: 0;
}

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}
.separador-contenedor .linea {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
}

.separador-contenedor .rombo {
  color: #ffffff;
  font-size: 10px;
  opacity: 0.85;
  line-height: 1;
}
.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: .95;
}

.icono-sobre{
  width: 150px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
}
.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}
</style>